import styled, { css } from 'styled-components';
import { H3, H4, Paragraph, paragraphCss } from 'components/ui/Typography';

import * as colors from 'theme/colors';
import { deviceSmallMax } from 'theme/mediaQueries';
import { spacing1x, spacing05x, spacing2x } from 'theme/spacings';
import { fontWeightMedium, fontWeightSemiBold } from 'theme/typography';

export const ImageWrapper = styled.div`
	position: relative;
	/* height is temporary */
	height: 20.8rem;
	@media (max-width: ${deviceSmallMax}) {
		height: 16rem;
	}
`;

interface HeadingModel {
	as: string;
	size: string;
	isLindab?: boolean;
}

export const Heading = styled(H4).attrs((props: HeadingModel) => ({
	as: props.as,
	size: props.size,
	isLindab: props.isLindab,
}))`
	${H3};
	color: ${colors.blue};
	font-weight: ${fontWeightMedium};
	margin: ${spacing1x} 0 0 0;
	${({ isLindab }) =>
		isLindab &&
		css`
			font-weight: ${fontWeightSemiBold};
			font-size: 2.4rem;
			line-height: 2.6rem;
			margin-bottom: ${spacing1x};
			margin-top: ${spacing2x};
		`}
`;

export const Description = styled.span`
	${paragraphCss};
	color: ${colors.blue};
`;

export const BlockLink = styled.a`
	display: block;
	text-decoration: none;

	:hover ${Heading} {
		text-decoration: underline;
	}
`;

export const Text = styled(Paragraph)`
	color: ${colors.black};
	margin: ${spacing05x} 0 0 0;
`;

interface LabelModel {
	color: string;
	isLindab?: boolean;
}

const labelDefault = css`
	text-transform: uppercase;
	font-weight: ${fontWeightMedium};
	bottom: 0.9rem;
	left: -0.5rem;
	border-radius: 0;
	font-size: 1.3rem;
`;

const labelLindab = css`
	text-transform: capitalize;
	font-weight: ${fontWeightSemiBold};
	top: 1.6rem;
	left: 1.6rem;
	border-radius: 0.8rem;
	font-size: 1.6rem;
`;

export const Label = styled.span.attrs((props: LabelModel) => ({
	color: props.color,
	isLindab: props.isLindab,
}))`
	background-color: ${({ color }) =>
		color === 'orange' ? colors.orangeLight : (colors as any)[color]};
	color: ${({ color }) => (color === 'lavender' ? colors.black : colors.white)};

	padding: ${spacing05x} ${spacing1x};
	position: absolute;
	${({ isLindab }) => (isLindab ? labelLindab : labelDefault)}
`;

export const IconCircleBackground = styled.span`
	position: absolute;
	right: -7.8rem;
	bottom: -40px;
	background-color: ${colors.beige};
	padding: 4.2rem 6.5rem;
	border-radius: 10rem;
	display: flex;
	height: fit-content;
`;

export const Image = styled.img`
	width: 100%;
	/* height is temporary */
	height: 100%;
	object-fit: cover;
	font-family: 'object-fit: cover;';
	position: relative;
	transition: all 2s ease-out;
	border: 0.1rem solid ${colors.greyDark};
`;

export const PublishedDate = styled(Paragraph)<{ isLindab?: boolean }>`
	margin: ${({ isLindab }) =>
		isLindab ? `${spacing1x} 0` : `${spacing05x} 0 -${spacing1x} 0`};
	color: ${({ isLindab }) => (isLindab ? colors.black : colors.greyDark)};
`;
